import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import QuestionBankViewer from './QuestionBankViewer';
import {main_url , DARK_BLUE} from  './basefile';
import FloatingbackButton from './Floatbt_backy';
import FloatinglogoutButton from './Floatbt_logout';

import {
  Box,
  TextField,
  MenuItem,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  Slider,
  Typography,
  Divider,
} from '@mui/material';

const QUESTION_TYPES = [
  { value: 'text', label: 'Text Input' },
  { value: 'single', label: 'Single' },
  { value: 'multiple', label: 'Multiple' },
  { value: 'slider', label: 'Slider' },
];


const QuestionnaireBuilder = () => {

  const { projectId } = useParams();

  const [questionText, setQuestionText] = useState('');
  const [answerType, setAnswerType] = useState('');
  const [newOption, setNewOption] = useState('');
  const [options, setOptions] = useState([]);
  const [questions, setQuestions] = useState([]);

  const handleAddOption = () => {
    if (newOption.trim()) {
      setOptions([...options, newOption.trim()]);
      setNewOption('');
    }
  };
  
  const handleAddQuestion = () => {
    if (!questionText || !answerType) return;

    const structuredOptions =
    ['multiple', 'single'].includes(answerType)
      ? [...new Set(options.filter(Boolean))].map((opt, i) => ({
          text: opt,
          value: `option_${i}`, // optional but useful
          label: opt            // optional if backend expects it
        }))
      : [];


    const newQuestion = {
      project: projectId,
      text: questionText,
      question_type: answerType,
      order: questions.length,  // need to correct this based on total Q for this project
      is_required: true,
      options: structuredOptions
    };

    setQuestions([...questions, newQuestion]);

    // Reset form
    setQuestionText('');
    setAnswerType('');
    setOptions([]);
    setNewOption('');
  };

  const submitToAPI = async () => {

    // get the total question count 
    const payload = questions.map((q, idx) => (
      {
      ...q,
      order: idx, // update order before sending
    }
  
  ));
    const token  = localStorage.getItem('authToken');
    const project_pk = projectId;
    //alert(project_pk);

    try {
       for (const q of payload) {
      const res = await fetch(`${main_url}/api/v1/projects/${project_pk}/questions/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(q),
      });

      if (!res.ok) {
        const error = await res.text();
        throw new Error(`API error: ${error}`);
      }
    
      const data = await res.json();
      //alert(JSON.stringify(data));
      console.log('✅ Submitted:', data);
    }
      alert('Questions submitted successfully!');
      setQuestions([]);
    } catch (err) {
      console.error('❌ Submission failed:', err.message);
      alert('Failed to submit questions.');
    }
  };

  return (
<Box  sx={{
      //    bgcolor: '#cce2eeff',
      bgcolor: '#dde7ecff',
                 
                   }}>

   <Box
      sx={{ pt:5,
        height: 120,
        bgcolor:   DARK_BLUE,
        textAlign: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        borderRadius: 0,

      }}
    >
      <Typography variant="h4" fontWeight="bold">
        Add Questions
      </Typography>
    </Box>
    <Box p={3} mt={3} maxWidth={900} mx="auto"  bgcolor="#f5f5f5" sx={{ borderRadius: 3,}}  >
      <br></br> <br></br>
      <Typography variant="h5" gutterBottom fontWeight={"bold"}>
        Add New Question 
      </Typography>

      <TextField
        fullWidth
        label="Enter your question"
        value={questionText}
        onChange={(e) => setQuestionText(e.target.value)}
        margin="normal"
      />

      <TextField
        select
        fullWidth
        label="Select Answer Type"
        value={answerType}
        onChange={(e) => {
          setAnswerType(e.target.value);
          setOptions([]);
        }}
        margin="normal"
      >
        {QUESTION_TYPES.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>

      {['multiple', 'single', 'select'].includes(answerType) && (
        <Box mt={2}>
          <Box display="flex" gap={1} mb={1}>
            <TextField
              label="New Option"
              value={newOption}
              onChange={(e) => setNewOption(e.target.value)}
              size="small"
            />
            <Button onClick={handleAddOption} variant="outlined">
              Add Option
            </Button>
          </Box>
          {options.map((opt, idx) => (
            <FormControlLabel
              key={idx}
              //control={answerType === 'multiple' ? <Radio disabled /> : <Checkbox disabled />}
              control={ <Radio disabled /> }
              label={opt}
            />
          ))}
        </Box>
      )}

      {answerType === 'text' && (
        <TextField
          fullWidth
          label="Text Answer (preview)"
          placeholder="User will type answer here"
          disabled
          margin="normal"
        />
      )}

      {answerType === 'slider' && (
        <Box mt={3}>
          <Slider defaultValue={50} valueLabelDisplay="auto" disabled />
        </Box>
      )}

      <Box mt={2}>
        <Button variant="contained" onClick={handleAddQuestion}>
          Add Question
        </Button>
      </Box>

      <Divider sx={{ my: 4 }} />

      <Typography variant="h5">Questions Preview</Typography>
      {questions.map((q, index) => (
        <Box key={index} my={2} p={2} border="1px solid #ccc" borderRadius={2}>
          <Typography fontWeight="bold">
            Q{index + 1}: {q.text}
          </Typography>
          <Typography variant="body2">Type: {q.question_type}</Typography>
          {q.options.length > 0 && (
            <ul>
              {q.options.map((opt, i) => (
                <li key={i}>{opt.text}</li>
              ))}
            </ul>
          )}
        </Box>
      ))}

      {questions.length > 0 && (
        <Box mt={3} display="flex" gap={2}   justifyContent="center" >
          <Button variant="contained" color="primary"  onClick={submitToAPI}>
            Add to this Project
          </Button>
         
        </Box>
      )}
      <Divider sx={{ my: 4 }} />
      </Box>
  <br></br><br></br>
       <Box >
      <QuestionBankViewer projectId = {projectId}/>
      </Box>
      <FloatingbackButton />
      
    
    </Box>
  );
}

export default QuestionnaireBuilder;
